import Vue from 'vue/dist/vue.esm'

Vue.component(
  'documents-options-modal-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/documents/OptionsModal")
)
